export function NumberFormat(number: number, currency?: 'EUR' | 'CHF'): string {

    switch (currency) {
        case 'CHF':
            return 'CHF ' + new Intl.NumberFormat('de-CH', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(number);

        case 'EUR':
            return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(number) + ' €';

        default:
            return new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(number);
    }


}
